<template>
  <div class="pag-wrap">
    <my-header
        :current-title="['税务数字账户','发票入账标识']"
        v-bind="$attrs"
    />

    <div class="content-box">

      <el-card style="margin-top: 20px;">
        <el-tabs v-model="activeName">
          <el-tab-pane label="发票" name="发票">
            <el-form :model="queryParams" ref="formRef"
                     inline
                     size="large"
                     :rules="rules" label-width="130px">
              <el-form-item label="入账状态" prop="entryStatus">
                <el-select
                    v-model="queryParams.entryStatus"
                    style="width: 237px;"
                    placeholder="请选择">
                  <el-option label="未入账" value="1"/>
                  <el-option label="已入账（企业所得税税前扣除）" value="2"/>
                  <el-option label="已入账（企业所得税不扣除）" value="3"/>
                  <el-option label="入账撤销" value="4"/>
                </el-select>
              </el-form-item>

              <el-form-item label="发票来源" prop="source">
                <el-select
                    v-model="queryParams.source"
                    style="width: 237px;"
                    placeholder="请选择">
                  <el-option label="全部" value="1"/>
                  <el-option label="增值税发票管理系统" value="2"/>
                  <el-option label="电子发票服务平台" value="3"/>
                </el-select>
              </el-form-item>

              <el-form-item label="票种" prop="ticketType">
                <el-select
                    multiple
                    collapse-tags
                    clearable
                    v-model="queryParams.ticketType"
                    style="width: 237px;"
                    placeholder="请选择">
                  <template #header>
                    <el-checkbox
                        v-model="checkTicketTypeAll"
                        :indeterminate="ticketTypeIndeterminate"
                        @change="handleCheckAll"
                    >
                      全选
                    </el-checkbox>
                  </template>

                  <el-option label="数电票(铁路电子客票)" value="1"/>
                  <el-option label="数电票(增值税专用发票)" value="2"/>
                  <el-option label="数电票(普通发票)" value="3"/>
                  <el-option label="数电票(机动车销售统一发票)" value="4"/>
                  <el-option label="数电票(二手车销售统一发票)" value="5"/>
                  <el-option label="数电纸质发票(增值税专用发票)" value="6"/>
                  <el-option label="数电纸质发票(普通发票)" value="7"/>
                  <el-option label="数电纸质发票(机动车销售统一发票)" value="8"/>
                  <el-option label="数电纸质发票(二手车销售统一发票)" value="9"/>
                  <el-option label="数电票(航空运输电子客票行程单)" value="10"/>
                  <el-option label="数电票(通行费发票)" value="11"/>
                  <el-option label="机动车销售统一发票" value="12"/>
                  <el-option label="二手车销售统一发票" value="13"/>

                  <el-option label="增值税专用发票" value="14"/>
                  <el-option label="增值税电子专用发票" value="15"/>
                  <el-option label="增值税普通发票" value="16"/>
                  <el-option label="增值税电子普通发票" value="17"/>
                  <el-option label="道路通行费电子普通发票" value="18"/>
                  <el-option label="增值税普通发票(卷式)" value="19"/>
                </el-select>
              </el-form-item>

              <el-form-item label="发票状态" prop="invoiceStatus">
                <el-select
                    multiple
                    collapse-tags
                    v-model="queryParams.invoiceStatus"
                    style="width: 237px;"
                    placeholder="请选择">
                  <template #header>
                    <el-checkbox
                        v-model="checkInvoiceStatusAll"
                        :indeterminate="invoiceStatusIndeterminate"
                        @change="handleInvoiceStatusCheckAll"
                    >
                      全选
                    </el-checkbox>
                  </template>
                  <el-option label="正常" value="1"/>
                  <el-option label="已作废" value="2"/>
                  <el-option label="已红冲-全额" value="3"/>
                  <el-option label="已红冲-部分" value="4"/>
                </el-select>
              </el-form-item>

              <el-form-item label="数电票号码" prop="allInvoiceNumber">
                <el-input
                    v-model="queryParams.allInvoiceNumber"
                    placeholder="请输入"
                    clearable
                    maxlength="50"
                    style="width: 237px;"
                />
              </el-form-item>

              <el-form-item label="发票代码" prop="invoiceCode">
                <el-input
                    v-model="queryParams.invoiceCode"
                    placeholder="请输入"
                    clearable
                    maxlength="50"
                    style="width: 237px;"
                />
              </el-form-item>

              <el-form-item label="发票号码" prop="invoiceNumber">
                <el-input
                    v-model.trim="queryParams.invoiceNumber"
                    placeholder="请输入"
                    clearable
                    maxlength="50"
                    style="width: 237px;"
                />
              </el-form-item>

              <el-form-item label="发票风险等级" prop="riskLevel">
                <el-select
                    v-model="queryParams.riskLevel"
                    style="width: 237px;"
                    placeholder="请选择">
                  <el-option label="正常" value="1"/>
                  <el-option label="异常凭证" value="2"/>
                  <el-option label="疑点发票" value="3"/>
                </el-select>
              </el-form-item>

              <el-form-item label="开票日期（起）" prop="startTime">
                <el-date-picker
                    v-model="queryParams.startTime"
                    type="date"
                    style="width: 237px;"
                    value-format="YYYY-MM-DD"
                    placeholder="请选择"
                    :disabled-date="disableStart"
                />
              </el-form-item>

              <el-form-item label="开票日期（止）" prop="endTime">
                <el-date-picker
                    v-model="queryParams.endTime"
                    type="date"
                    style="width: 237px;"
                    value-format="YYYY-MM-DD"
                    placeholder="请选择"
                    :disabled-date="disableEnd"
                />
              </el-form-item>

              <el-form-item prop="sellerCode">
                <template #label>
                  <span style=" white-space: nowrap;overflow: visible;">销售方纳税人识别号</span>
                </template>
                <template #default>
                  <el-input
                      v-model="queryParams.sellerCode"
                      placeholder="请输入"
                      clearable
                      maxlength="50"
                      style="width: 237px;"
                  />
                </template>
              </el-form-item>

              <el-form-item label="销售方纳税人名称" prop="sellerName">
                <el-input
                    v-model="queryParams.sellerName"
                    placeholder="请输入"
                    clearable
                    maxlength="50"
                    style="width: 237px;"
                />
              </el-form-item>

              <el-form-item label="选择机构" prop="chooseGroup">
                <el-select
                    v-model="queryParams.chooseGroup"
                    style="width: 237px;"
                    disabled
                    placeholder="请选择">
                  <el-option label="机构" value="1"/>
                </el-select>
              </el-form-item>

              <el-form-item style="float: right;">
                <el-button type="info" disabled>重置</el-button>
                <el-button type="primary" @click="queryData(true)">查询</el-button>
                <el-button icon="ArrowUp" disabled>收起</el-button>
              </el-form-item>
            </el-form>

            <div style="display: flex;align-items: center;">
              <el-button
                  size="large"
                  type="primary">清单导入
              </el-button>
              <el-button
                  size="large"
                  disabled
                  type="info">导出
              </el-button>
              <el-button
                  size="large"
                  disabled
                  type="info">批量选择入账用途
              </el-button>
              <el-button
                  size="large"
                  disabled
                  type="info">批量选择入账时间
              </el-button>
              <div style="flex-grow: 1;"></div>

              <el-button
                  disabled
                  size="large">自定义列
              </el-button>
            </div>

            <el-table
                ref="tableRef"
                :data="tableList"
                style="margin-top: 10px;"
                :cell-style="{ 'background': ['2', '3'].includes(queriedParams.entryStatus) ? '#edeef2' : undefined }"
                border
                @selection-change="handleTableSelect"
            >
              <el-table-column type="selection" label="勾选" fixed="left" align="center" width="60"/>

              <el-table-column type="index" label="序号" fixed="left" align="center" width="60"/>

              <el-table-column label="入账状态" align="center" width="230">
                <template #default="{row}">
                  <el-select
                      v-model="row.entryStatus"
                      style="width: 180px;"
                      :disabled="['2', '3'].includes(queriedParams.entryStatus)"
                      placeholder="请选择">
                    <el-option label="已入账（企业所得税税前扣除）" value="2"/>
                    <el-option label="已入账（企业所得税不扣除）" value="3"/>
                    <el-option label="入账撤销" value="4"/>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column label="入账时间" align="center" width="200">
                <template #default="{row}">
                  <el-date-picker
                      v-model="row.entryTime"
                      type="date"
                      :disabled="['2', '3'].includes(queriedParams.entryStatus)"
                      style="width: 160px;"
                      value-format="YYYY-MM-DD"
                      placeholder="选择日期"
                  />
                </template>
              </el-table-column>

              <el-table-column label="发票状态" align="center" prop="invoiceStatus" width="150"/>

              <el-table-column label="红字锁定标志" align="center" width="150">
                <template #default="{row}">
                  <span>否</span>
                </template>
              </el-table-column>

              <el-table-column label="发票风险状态" align="center" prop="riskLevel" width="150">
                <template #default="{row}">
                  <el-tag type="success">正常</el-tag>
                </template>
              </el-table-column>

              <el-table-column label="数电票号码" align="center" prop="allInvoiceNumber" width="180"/>

              <el-table-column label="发票代码" align="center" prop="invoiceCode" width="150"/>

              <el-table-column label="发票号码" align="center" prop="invoiceNumber" width="150"/>

              <el-table-column label="开票日期" align="center" prop="invoiceDate" width="150"/>

              <el-table-column label="销售方纳税人识别号" align="center" prop="sellerCode" width="180"/>

              <el-table-column label="销售方纳税人名称" align="center" prop="sellerName" width="150"/>

              <el-table-column label="金额" align="center" prop="amount" width="150">
                <template #default="{row}">
                  <span>{{ row.amount != null ? row.amount.toFixed(2) : '0.00' }}</span>
                </template>
              </el-table-column>

              <el-table-column label="税额" align="center" prop="taxAmount" width="150">
                <template #default="{row}">
                  <span>{{ row.taxAmount != null ? row.taxAmount.toFixed(2) : '0.00' }}</span>
                </template>
              </el-table-column>

              <el-table-column label="票种" align="center" prop="invoiceType" width="150"/>
            </el-table>

            <div class="paginate-wrap">
              <span class="total">共 {{ pageTotal }} 条</span>
              <pagination
                  :total="pageTotal"
                  v-model:page="queryParams.pageNum"
                  v-model:limit="queryParams.pageSize"
                  layout="sizes,prev, pager, next, jumper"
              />
            </div>
          </el-tab-pane>

          <el-tab-pane label="海关缴款书" name="海关缴款书">
            <el-empty description="暂无内容"/>
          </el-tab-pane>

          <el-tab-pane label="代扣代缴完税凭证" name="代扣代缴完税凭证">
            <el-empty description="暂无内容"/>
          </el-tab-pane>

        </el-tabs>
      </el-card>

      <footer style="display: flex;justify-content: center;padding: 30px 0;">
        <img src="https://static.rhkj.com/renhe_fe/other/333.png">
      </footer>
    </div>

    <div class="bottom">
      <el-button
          v-if="['1','4'].includes(queriedParams.entryStatus)"
          size="large"
          type="primary"
          @click="submit">提交入账
      </el-button>

      <el-button
          v-else-if="['2','3'].includes(queriedParams.entryStatus)"
          size="large"
          type="primary"
          @click="revokeSubmit">撤销入账
      </el-button>
    </div>
  </div>
</template>


<script setup lang="jsx">
// 发票入账标识做题主页面
import myHeader from "./cmp/myHeader.vue";
import {$emit, $on} from "vue-happy-bus";
import {ElMessage, ElMessageBox} from "element-plus";
import Big from "big.js";
import dayjs from "dayjs";

const props = defineProps({
  currentQa: { // 当前题目信息对象
    required: true,
    type: Object,
  },
})

const activeName = ref('发票')


const queryParams = reactive({
  entryStatus: '1',
  source: '1',
  ticketType: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'],
  ticketStatus: ["1"],
  pageNum: 1,
  pageSize: 50,
  invoiceStatus: ['1', '4'],
})

const rules = reactive({})

let savedData = ref({ // 保存到服务器的列
  alreadyBeforeRows: [], // 已入账（企业所得税税前扣除）的列
  alreadyNeverRows: [],//已入账（企业所得税不扣除）
  revokeRows: [], //入账撤销列
})
const allInitialList = ref([])
const pageTotal = ref(0)
const tableList = ref([])
const tableRef = ref()
const selectRows = ref([])

function handleTableSelect(rows) {
  selectRows.value = rows
}

const currentQa = inject('provideCurrentQa');
const allQaList = inject('provideAllQa');

onMounted(() => {
  // 1.已经保存的数据还原
  savedData.value = {
    ...savedData.value,
    ...JSON.parse(props.currentQa?.solution || "{}"),
  }

  // 2.获取全部的初始数据
  const currentIndex = allQaList.value.findIndex(f => f.queId == currentQa.value.queId) // 当前题目下标
  const prevDk = allQaList.value[currentIndex - 1]
  if (prevDk.sonQueType != '43') {
    ElMessage.error('税务数字账户题目取数失败，请联系校区老师反馈')
    return
  }
  allInitialList.value = prevDk.solution && JSON.parse(prevDk.solution)?.checkRows || [] //数据需从“发票勾选认证”题型中获取已勾选的发票数据

  console.log('取的前面1题数据', allInitialList.value)

  // 3.搜索栏--开票日期筛选 默认值设置
  let maxDate, minDate
  if (allInitialList.value.length > 0) {
    maxDate = dayjs(allInitialList.value[0].invoiceDate, 'YYYY-MM-DD')
    minDate = dayjs(allInitialList.value[0].invoiceDate, 'YYYY-MM-DD')
  } else {
    minDate = dayjs('2026-01-01', 'YYYY-MM-DD')
    maxDate = dayjs('2026-12-31', 'YYYY-MM-DD')
  }

  allInitialList.value.forEach(e => {
    const current = dayjs(e.invoiceDate, 'YYYY-MM-DD HH:mm:ss')
    if (current.isAfter(maxDate)) {
      maxDate = current
    }
    if (current.isBefore(minDate)) {
      minDate = current
    }
  })
  queryParams.startTime = minDate.startOf('day').format('YYYY-MM-DD')
  queryParams.endTime = maxDate.endOf('day').format('YYYY-MM-DD')

  // 3.默认查询一次
  queryData(false)
})

// 提交入账
function submit() {
  if (selectRows.value.length == 0) {
    ElMessage.error('请选择要入账的数据！')
    return
  }
  const rows = tableRef.value.getSelectionRows()
  let taxAmountTotal = new Big(0)

  rows.forEach(row => {
    taxAmountTotal = taxAmountTotal.plus(row.taxAmount)
  })
  const vnode = (
      <div
          style="color:#555555;line-height:22px;letter-spacing: 0.3px;display:flex;flex-direction: column; align-items: center;width:400px;">
        <img style="display:block;width:32px;height:32px;" src="https://static.rhkj.com/renhe_fe/other/334.png"></img>
        <div style="font-size: 20px;">提交入账</div>
        <div>本次入账发票 {rows.length} 份,税额合计{taxAmountTotal.toFixed(2)}</div>
        <br/>
        <div>是否确认提交?</div>
      </div>
  );
  ElMessageBox.alert(vnode, '提示', {
    cancelButtonText: '取消',
    confirmButtonText: '确认提交',
    showCancelButton: true,
  })
      .then(() => {
        if (rows.some(s => !s.entryStatus || (['2', '3'].includes(s.entryStatus) && !s.entryTime))) {
          ElMessage.error('更新异常')
          return
        }
        $emit('exeSaveQa', {type: 1}) // 1 提交入账  2撤销入账
      })
      .catch(() => {
      })
}

//撤销入账
function revokeSubmit() {
  if (selectRows.value.length == 0) {
    ElMessage.error('请选择要撤销的数据！')
    return
  }
  const rows = tableRef.value.getSelectionRows()
  let taxAmountTotal = new Big(0)

  rows.forEach(row => {
    taxAmountTotal = taxAmountTotal.plus(row.taxAmount)
  })
  const vnode = (
      <div
          style="color:#555555;line-height:22px;letter-spacing: 0.3px;display:flex;flex-direction: column; align-items: center;width:400px;">
        <img style="display:block;width:32px;height:32px;" src="https://static.rhkj.com/renhe_fe/other/334.png"></img>
        <div style="font-size: 20px;">入账撤销</div>
        <div>本次撤销发票 {rows.length} 份,税额合计{taxAmountTotal.toFixed(2)}</div>
        <br/>
        <div>是否确认撤销?</div>
      </div>
  );
  ElMessageBox.alert(vnode, '提示', {
    cancelButtonText: '取消',
    confirmButtonText: '确认撤销',
    showCancelButton: true,
  })
      .then(() => {
        $emit('exeSaveQa', {type: 2}) // 1 提交入账  2撤销入账
      })
      .catch(() => {
      })
}

const getGrandchildValue = inject('getGrandchildValue');
getGrandchildValue.value.getData = (byUser, params) => {
  const rows = tableRef.value && tableRef.value.getSelectionRows() || []

  let alreadyBeforeRows = savedData.value.alreadyBeforeRows
  let alreadyNeverRows = savedData.value.alreadyNeverRows
  let revokeRows = savedData.value.revokeRows
  if (params.type == 1) { // 提交入账
    alreadyBeforeRows = alreadyBeforeRows.concat(rows.filter(f => f.entryStatus == '2'))
    alreadyNeverRows = alreadyNeverRows.concat(rows.filter(f => f.entryStatus == '3'))
    revokeRows = revokeRows.concat(rows.filter(f => f.entryStatus == '4' && !revokeRows.some(s => s.invoiceCode == f.invoiceCode)))
        .filter(f => !(rows.some(s => ['2', '3'].includes(s.entryStatus) && f.invoiceCode == s.invoiceCode)))
  } else if (params.type == 2) { // 撤销入账
    alreadyBeforeRows = alreadyBeforeRows.filter(f => !rows.some(s => s.invoiceCode == f.invoiceCode))
    alreadyNeverRows = alreadyNeverRows.filter(f => !rows.some(s => s.invoiceCode == f.invoiceCode))
    revokeRows = revokeRows.concat(rows).map(m => ({
      ...m,
      entryStatus: '4',
      entryTime: undefined,
    }))
  }

  return {
    solution: JSON.stringify({
      alreadyBeforeRows: alreadyBeforeRows.filter(f => allInitialList.value.some(s => s.invoiceCode == f.invoiceCode)),
      alreadyNeverRows: alreadyNeverRows.filter(f => allInitialList.value.some(s => s.invoiceCode == f.invoiceCode)),
      revokeRows: revokeRows.filter(f => allInitialList.value.some(s => s.invoiceCode == f.invoiceCode)),
    }) || '',
  }
}

getGrandchildValue.value.fillFinish = () => {
  return Boolean(savedData.value.alreadyBeforeRows.length) || Boolean(savedData.value.alreadyNeverRows.length)
}

// 爷爷组件，保存成功回调
$on('saveQaSuccess', res => {
  if (res.byUser) {
    savedData.value = {
      ...savedData.value,
      ...JSON.parse(res?.serverData?.solution || "{}"),
    }
    ElMessage.success('成功')
    queryData(false)
  }
})


let queriedParams = ref({}) // 已经查询的查询参数，接口执行后自动赋值

// 点击查询
function queryData(byUser) {
  queriedParams.value = JSON.parse(JSON.stringify(queryParams))

  let resList
  if (queryParams.entryStatus == '1') { // 查询未入账的
    resList = allInitialList.value
        .filter(f =>
            !savedData.value.alreadyBeforeRows.some(s => s.invoiceCode === f.invoiceCode) &&
            !savedData.value.alreadyNeverRows.some(s => s.invoiceCode === f.invoiceCode) &&
            !savedData.value.revokeRows.some(s => s.invoiceCode === f.invoiceCode)
        );
  } else if (queryParams.entryStatus == '2') { // 已入账（企业所得税税前扣除）
    resList = savedData.value.alreadyBeforeRows.filter(f => allInitialList.value.some((s => s.invoiceCode == f.invoiceCode)))
  } else if (queryParams.entryStatus == '3') { //已入账（企业所得税不扣除）
    resList = savedData.value.alreadyNeverRows.filter(f => allInitialList.value.some((s => s.invoiceCode == f.invoiceCode)))
  } else if (queryParams.entryStatus == '4') { // 撤销
    resList = savedData.value.revokeRows.filter(f => allInitialList.value.some((s => s.invoiceCode == f.invoiceCode)))
  }

  // 时间过滤实现
  resList = resList.filter(f => {
    const current = dayjs(f.invoiceDate, 'YYYY-MM-DD HH:mm:ss')
    const min = dayjs(queryParams.startTime + ' 00:00:00', 'YYYY-MM-DD HH:mm:ss')
    const max = dayjs(queryParams.endTime + ' 23:59:59', 'YYYY-MM-DD HH:mm:ss')
    return current.isAfter(min) && current.isBefore(max)
  })

  if (queryParams.invoiceNumber) {
    resList = resList.filter(f => f.invoiceNumber.toString().indexOf(queryParams.invoiceNumber) > -1)
  }
  if (queryParams.invoiceCode) {
    resList = resList.filter(f => f.invoiceCode.toString().indexOf(queryParams.invoiceCode) > -1)
  }
  if (queryParams.allInvoiceNumber) {
    resList = resList.filter(f => f.allInvoiceNumber.indexOf(queryParams.allInvoiceNumber) > -1)
  }

  tableList.value = resList
  pageTotal.value = resList.length

}

const checkTicketTypeAll = ref(true)
const ticketTypeIndeterminate = ref(false)

watch(() => queryParams.ticketType, (val) => {
  if (val.length === 0) {
    checkTicketTypeAll.value = false
    ticketTypeIndeterminate.value = false
  } else if (val.length === 19) {
    checkTicketTypeAll.value = true
    ticketTypeIndeterminate.value = false
  } else {
    ticketTypeIndeterminate.value = true
  }
})

const handleCheckAll = (val) => {
  ticketTypeIndeterminate.value = false
  if (val) {
    queryParams.ticketType = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19']
  } else {
    queryParams.ticketType = []
  }
}

const checkInvoiceStatusAll = ref(false)
const invoiceStatusIndeterminate = ref(true)

watch(() => queryParams.invoiceStatus, (val) => {
  if (val.length === 0) {
    checkInvoiceStatusAll.value = false
    invoiceStatusIndeterminate.value = false
  } else if (val.length === 4) {
    checkInvoiceStatusAll.value = true
    invoiceStatusIndeterminate.value = false
  } else {
    invoiceStatusIndeterminate.value = true
  }
})

const handleInvoiceStatusCheckAll = (val) => {
  invoiceStatusIndeterminate.value = false
  if (val) {
    queryParams.invoiceStatus = ['1', '2', '3', '4']
  } else {
    queryParams.invoiceStatus = []
  }
}

function disableStart(date) {
  // 开始时间不能大于结束时间
  if (queryParams.endTime && dayjs(date).isAfter(dayjs(queryParams.endTime, 'YYYY-MM-DD').startOf('day'))) {
    return true
  }
  return false
}

function disableEnd(date) {
  // 开始时间不能大于结束时间
  if (queryParams.startTime && dayjs(date).isBefore(dayjs(queryParams.startTime, 'YYYY-MM-DD').startOf('day'))) {
    return true
  }
  return false
}
</script>


<style scoped lang="scss">
.pag-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;

  .content-box {
    flex-grow: 1;
    background-color: #f2f2f2;
    box-sizing: border-box;
    padding: 20px 40px;
    overflow-y: auto;

    .paginate-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 5px;

      .total {
        color: #666666;
        font-size: 14px;
      }
    }
  }

  .bottom {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
